import { render, staticRenderFns } from "./InfoCircle.vue?vue&type=template&id=334a4ca7"
import script from "./InfoCircle.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoCircle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports